/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as TenantSelectionRouteImport } from './routes/tenant-selection';
import { Route as TenantPlaneRouteImport } from './routes/tenant-plane';
import { Route as SupportRouteImport } from './routes/support';
import { Route as StepUpRouteImport } from './routes/step-up';
import { Route as SignInRouteImport } from './routes/sign-in';
import { Route as SettingsRouteImport } from './routes/settings';
import { Route as RuntimeCockpitRouteImport } from './routes/runtime-cockpit';
import { Route as ReportsRouteImport } from './routes/reports';
import { Route as QueriesRouteImport } from './routes/queries';
import { Route as PluginsRouteImport } from './routes/plugins';
import { Route as PermissionCeremonyRouteImport } from './routes/permission-ceremony';
import { Route as OpsRouteImport } from './routes/ops';
import { Route as OnboardingRouteImport } from './routes/onboarding';
import { Route as NotificationsRouteImport } from './routes/notifications';
import { Route as LoginRouteImport } from './routes/login';
import { Route as IngestRouteImport } from './routes/ingest';
import { Route as DocumentsRouteImport } from './routes/documents';
import { Route as DevhubRouteImport } from './routes/devhub';
import { Route as DashboardRouteImport } from './routes/dashboard';
import { Route as ClientWorkroomRouteImport } from './routes/client-workroom';
import { Route as ChatRouteImport } from './routes/chat';
import { Route as AutomationsRouteImport } from './routes/automations';
import { Route as IndexRouteImport } from './routes/index';
import { Route as DevhubIndexRouteImport } from './routes/devhub.index';
import { Route as TenantPlaneSpokeIdRouteImport } from './routes/tenant-plane.$spokeId';
import { Route as PluginsPluginIdRouteImport } from './routes/plugins.$pluginId';
import { Route as DevhubWorkflowsRouteImport } from './routes/devhub.workflows';
import { Route as DevhubWorkersRouteImport } from './routes/devhub.workers';
import { Route as DevhubWhiteLabelRouteImport } from './routes/devhub.white-label';
import { Route as DevhubTracesRouteImport } from './routes/devhub.traces';
import { Route as DevhubToolGatewayRouteImport } from './routes/devhub.tool-gateway';
import { Route as DevhubTasksRouteImport } from './routes/devhub.tasks';
import { Route as DevhubSystemMapRouteImport } from './routes/devhub.system-map';
import { Route as DevhubSettingsRouteImport } from './routes/devhub.settings';
import { Route as DevhubSelfUpdateRouteImport } from './routes/devhub.self-update';
import { Route as DevhubSecretsRouteImport } from './routes/devhub.secrets';
import { Route as DevhubScriptsRouteImport } from './routes/devhub.scripts';
import { Route as DevhubSchedulerRouteImport } from './routes/devhub.scheduler';
import { Route as DevhubRuntimeControlRouteImport } from './routes/devhub.runtime-control';
import { Route as DevhubRuntimeCockpitRouteImport } from './routes/devhub.runtime-cockpit';
import { Route as DevhubRuntimeRouteImport } from './routes/devhub.runtime';
import { Route as DevhubResourcesRouteImport } from './routes/devhub.resources';
import { Route as DevhubRequestsRouteImport } from './routes/devhub.requests';
import { Route as DevhubReportTemplatesRouteImport } from './routes/devhub.report-templates';
import { Route as DevhubRemoteDbRouteImport } from './routes/devhub.remote-db';
import { Route as DevhubReleaseRouteImport } from './routes/devhub.release';
import { Route as DevhubRagRouteImport } from './routes/devhub.rag';
import { Route as DevhubPlatformRouteImport } from './routes/devhub.platform';
import { Route as DevhubModelsRouteImport } from './routes/devhub.models';
import { Route as DevhubInvitesRouteImport } from './routes/devhub.invites';
import { Route as DevhubIntakeRouteImport } from './routes/devhub.intake';
import { Route as DevhubInboxRouteImport } from './routes/devhub.inbox';
import { Route as DevhubGovernanceRouteImport } from './routes/devhub.governance';
import { Route as DevhubFinopsRouteImport } from './routes/devhub.finops';
import { Route as DevhubFilesRouteImport } from './routes/devhub.files';
import { Route as DevhubFileIngestionRouteImport } from './routes/devhub.file-ingestion';
import { Route as DevhubExecTracesRouteImport } from './routes/devhub.exec-traces';
import { Route as DevhubEvidenceRouteImport } from './routes/devhub.evidence';
import { Route as DevhubEmbeddingAtlasRouteImport } from './routes/devhub.embedding-atlas';
import { Route as DevhubContextPacksRouteImport } from './routes/devhub.context-packs';
import { Route as DevhubAuditRouteImport } from './routes/devhub.audit';
import { Route as DevhubAiChatRouteImport } from './routes/devhub.ai-chat';
import { Route as DevhubAiRouteImport } from './routes/devhub.ai';
import { Route as DevhubAgentsRouteImport } from './routes/devhub.agents';
import { Route as DevhubAdobeRouteImport } from './routes/devhub.adobe';
import { Route as DevhubActivationRouteImport } from './routes/devhub.activation';
import { Route as DevhubActionFramesRouteImport } from './routes/devhub.action-frames';
import { Route as ControlPlaneSpokeIdRouteImport } from './routes/control-plane.$spokeId';

const TenantSelectionRoute = TenantSelectionRouteImport.update({
  id: '/tenant-selection',
  path: '/tenant-selection',
  getParentRoute: () => rootRouteImport,
} as any);
const TenantPlaneRoute = TenantPlaneRouteImport.update({
  id: '/tenant-plane',
  path: '/tenant-plane',
  getParentRoute: () => rootRouteImport,
} as any);
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any);
const StepUpRoute = StepUpRouteImport.update({
  id: '/step-up',
  path: '/step-up',
  getParentRoute: () => rootRouteImport,
} as any);
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any);
const RuntimeCockpitRoute = RuntimeCockpitRouteImport.update({
  id: '/runtime-cockpit',
  path: '/runtime-cockpit',
  getParentRoute: () => rootRouteImport,
} as any);
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any);
const QueriesRoute = QueriesRouteImport.update({
  id: '/queries',
  path: '/queries',
  getParentRoute: () => rootRouteImport,
} as any);
const PluginsRoute = PluginsRouteImport.update({
  id: '/plugins',
  path: '/plugins',
  getParentRoute: () => rootRouteImport,
} as any);
const PermissionCeremonyRoute = PermissionCeremonyRouteImport.update({
  id: '/permission-ceremony',
  path: '/permission-ceremony',
  getParentRoute: () => rootRouteImport,
} as any);
const OpsRoute = OpsRouteImport.update({
  id: '/ops',
  path: '/ops',
  getParentRoute: () => rootRouteImport,
} as any);
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any);
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const IngestRoute = IngestRouteImport.update({
  id: '/ingest',
  path: '/ingest',
  getParentRoute: () => rootRouteImport,
} as any);
const DocumentsRoute = DocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => rootRouteImport,
} as any);
const DevhubRoute = DevhubRouteImport.update({
  id: '/devhub',
  path: '/devhub',
  getParentRoute: () => rootRouteImport,
} as any);
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any);
const ClientWorkroomRoute = ClientWorkroomRouteImport.update({
  id: '/client-workroom',
  path: '/client-workroom',
  getParentRoute: () => rootRouteImport,
} as any);
const ChatRoute = ChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any);
const AutomationsRoute = AutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const DevhubIndexRoute = DevhubIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevhubRoute,
} as any);
const TenantPlaneSpokeIdRoute = TenantPlaneSpokeIdRouteImport.update({
  id: '/$spokeId',
  path: '/$spokeId',
  getParentRoute: () => TenantPlaneRoute,
} as any);
const PluginsPluginIdRoute = PluginsPluginIdRouteImport.update({
  id: '/$pluginId',
  path: '/$pluginId',
  getParentRoute: () => PluginsRoute,
} as any);
const DevhubWorkflowsRoute = DevhubWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubWorkersRoute = DevhubWorkersRouteImport.update({
  id: '/workers',
  path: '/workers',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubWhiteLabelRoute = DevhubWhiteLabelRouteImport.update({
  id: '/white-label',
  path: '/white-label',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubTracesRoute = DevhubTracesRouteImport.update({
  id: '/traces',
  path: '/traces',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubToolGatewayRoute = DevhubToolGatewayRouteImport.update({
  id: '/tool-gateway',
  path: '/tool-gateway',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubTasksRoute = DevhubTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubSystemMapRoute = DevhubSystemMapRouteImport.update({
  id: '/system-map',
  path: '/system-map',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubSettingsRoute = DevhubSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubSelfUpdateRoute = DevhubSelfUpdateRouteImport.update({
  id: '/self-update',
  path: '/self-update',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubSecretsRoute = DevhubSecretsRouteImport.update({
  id: '/secrets',
  path: '/secrets',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubScriptsRoute = DevhubScriptsRouteImport.update({
  id: '/scripts',
  path: '/scripts',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubSchedulerRoute = DevhubSchedulerRouteImport.update({
  id: '/scheduler',
  path: '/scheduler',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubRuntimeControlRoute = DevhubRuntimeControlRouteImport.update({
  id: '/runtime-control',
  path: '/runtime-control',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubRuntimeCockpitRoute = DevhubRuntimeCockpitRouteImport.update({
  id: '/runtime-cockpit',
  path: '/runtime-cockpit',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubRuntimeRoute = DevhubRuntimeRouteImport.update({
  id: '/runtime',
  path: '/runtime',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubResourcesRoute = DevhubResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubRequestsRoute = DevhubRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubReportTemplatesRoute = DevhubReportTemplatesRouteImport.update({
  id: '/report-templates',
  path: '/report-templates',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubRemoteDbRoute = DevhubRemoteDbRouteImport.update({
  id: '/remote-db',
  path: '/remote-db',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubReleaseRoute = DevhubReleaseRouteImport.update({
  id: '/release',
  path: '/release',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubRagRoute = DevhubRagRouteImport.update({
  id: '/rag',
  path: '/rag',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubPlatformRoute = DevhubPlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubModelsRoute = DevhubModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubInvitesRoute = DevhubInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubIntakeRoute = DevhubIntakeRouteImport.update({
  id: '/intake',
  path: '/intake',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubInboxRoute = DevhubInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubGovernanceRoute = DevhubGovernanceRouteImport.update({
  id: '/governance',
  path: '/governance',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubFinopsRoute = DevhubFinopsRouteImport.update({
  id: '/finops',
  path: '/finops',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubFilesRoute = DevhubFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubFileIngestionRoute = DevhubFileIngestionRouteImport.update({
  id: '/file-ingestion',
  path: '/file-ingestion',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubExecTracesRoute = DevhubExecTracesRouteImport.update({
  id: '/exec-traces',
  path: '/exec-traces',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubEvidenceRoute = DevhubEvidenceRouteImport.update({
  id: '/evidence',
  path: '/evidence',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubEmbeddingAtlasRoute = DevhubEmbeddingAtlasRouteImport.update({
  id: '/embedding-atlas',
  path: '/embedding-atlas',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubContextPacksRoute = DevhubContextPacksRouteImport.update({
  id: '/context-packs',
  path: '/context-packs',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubAuditRoute = DevhubAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubAiChatRoute = DevhubAiChatRouteImport.update({
  id: '/ai-chat',
  path: '/ai-chat',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubAiRoute = DevhubAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubAgentsRoute = DevhubAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubAdobeRoute = DevhubAdobeRouteImport.update({
  id: '/adobe',
  path: '/adobe',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubActivationRoute = DevhubActivationRouteImport.update({
  id: '/activation',
  path: '/activation',
  getParentRoute: () => DevhubRoute,
} as any);
const DevhubActionFramesRoute = DevhubActionFramesRouteImport.update({
  id: '/action-frames',
  path: '/action-frames',
  getParentRoute: () => DevhubRoute,
} as any);
const ControlPlaneSpokeIdRoute = ControlPlaneSpokeIdRouteImport.update({
  id: '/control-plane/$spokeId',
  path: '/control-plane/$spokeId',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/automations': typeof AutomationsRoute;
  '/chat': typeof ChatRoute;
  '/client-workroom': typeof ClientWorkroomRoute;
  '/dashboard': typeof DashboardRoute;
  '/devhub': typeof DevhubRouteWithChildren;
  '/documents': typeof DocumentsRoute;
  '/ingest': typeof IngestRoute;
  '/login': typeof LoginRoute;
  '/notifications': typeof NotificationsRoute;
  '/onboarding': typeof OnboardingRoute;
  '/ops': typeof OpsRoute;
  '/permission-ceremony': typeof PermissionCeremonyRoute;
  '/plugins': typeof PluginsRouteWithChildren;
  '/queries': typeof QueriesRoute;
  '/reports': typeof ReportsRoute;
  '/runtime-cockpit': typeof RuntimeCockpitRoute;
  '/settings': typeof SettingsRoute;
  '/sign-in': typeof SignInRoute;
  '/step-up': typeof StepUpRoute;
  '/support': typeof SupportRoute;
  '/tenant-plane': typeof TenantPlaneRouteWithChildren;
  '/tenant-selection': typeof TenantSelectionRoute;
  '/control-plane/$spokeId': typeof ControlPlaneSpokeIdRoute;
  '/devhub/action-frames': typeof DevhubActionFramesRoute;
  '/devhub/activation': typeof DevhubActivationRoute;
  '/devhub/adobe': typeof DevhubAdobeRoute;
  '/devhub/agents': typeof DevhubAgentsRoute;
  '/devhub/ai': typeof DevhubAiRoute;
  '/devhub/ai-chat': typeof DevhubAiChatRoute;
  '/devhub/audit': typeof DevhubAuditRoute;
  '/devhub/context-packs': typeof DevhubContextPacksRoute;
  '/devhub/embedding-atlas': typeof DevhubEmbeddingAtlasRoute;
  '/devhub/evidence': typeof DevhubEvidenceRoute;
  '/devhub/exec-traces': typeof DevhubExecTracesRoute;
  '/devhub/file-ingestion': typeof DevhubFileIngestionRoute;
  '/devhub/files': typeof DevhubFilesRoute;
  '/devhub/finops': typeof DevhubFinopsRoute;
  '/devhub/governance': typeof DevhubGovernanceRoute;
  '/devhub/inbox': typeof DevhubInboxRoute;
  '/devhub/intake': typeof DevhubIntakeRoute;
  '/devhub/invites': typeof DevhubInvitesRoute;
  '/devhub/models': typeof DevhubModelsRoute;
  '/devhub/platform': typeof DevhubPlatformRoute;
  '/devhub/rag': typeof DevhubRagRoute;
  '/devhub/release': typeof DevhubReleaseRoute;
  '/devhub/remote-db': typeof DevhubRemoteDbRoute;
  '/devhub/report-templates': typeof DevhubReportTemplatesRoute;
  '/devhub/requests': typeof DevhubRequestsRoute;
  '/devhub/resources': typeof DevhubResourcesRoute;
  '/devhub/runtime': typeof DevhubRuntimeRoute;
  '/devhub/runtime-cockpit': typeof DevhubRuntimeCockpitRoute;
  '/devhub/runtime-control': typeof DevhubRuntimeControlRoute;
  '/devhub/scheduler': typeof DevhubSchedulerRoute;
  '/devhub/scripts': typeof DevhubScriptsRoute;
  '/devhub/secrets': typeof DevhubSecretsRoute;
  '/devhub/self-update': typeof DevhubSelfUpdateRoute;
  '/devhub/settings': typeof DevhubSettingsRoute;
  '/devhub/system-map': typeof DevhubSystemMapRoute;
  '/devhub/tasks': typeof DevhubTasksRoute;
  '/devhub/tool-gateway': typeof DevhubToolGatewayRoute;
  '/devhub/traces': typeof DevhubTracesRoute;
  '/devhub/white-label': typeof DevhubWhiteLabelRoute;
  '/devhub/workers': typeof DevhubWorkersRoute;
  '/devhub/workflows': typeof DevhubWorkflowsRoute;
  '/plugins/$pluginId': typeof PluginsPluginIdRoute;
  '/tenant-plane/$spokeId': typeof TenantPlaneSpokeIdRoute;
  '/devhub/': typeof DevhubIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/automations': typeof AutomationsRoute;
  '/chat': typeof ChatRoute;
  '/client-workroom': typeof ClientWorkroomRoute;
  '/dashboard': typeof DashboardRoute;
  '/documents': typeof DocumentsRoute;
  '/ingest': typeof IngestRoute;
  '/login': typeof LoginRoute;
  '/notifications': typeof NotificationsRoute;
  '/onboarding': typeof OnboardingRoute;
  '/ops': typeof OpsRoute;
  '/permission-ceremony': typeof PermissionCeremonyRoute;
  '/plugins': typeof PluginsRouteWithChildren;
  '/queries': typeof QueriesRoute;
  '/reports': typeof ReportsRoute;
  '/runtime-cockpit': typeof RuntimeCockpitRoute;
  '/settings': typeof SettingsRoute;
  '/sign-in': typeof SignInRoute;
  '/step-up': typeof StepUpRoute;
  '/support': typeof SupportRoute;
  '/tenant-plane': typeof TenantPlaneRouteWithChildren;
  '/tenant-selection': typeof TenantSelectionRoute;
  '/control-plane/$spokeId': typeof ControlPlaneSpokeIdRoute;
  '/devhub/action-frames': typeof DevhubActionFramesRoute;
  '/devhub/activation': typeof DevhubActivationRoute;
  '/devhub/adobe': typeof DevhubAdobeRoute;
  '/devhub/agents': typeof DevhubAgentsRoute;
  '/devhub/ai': typeof DevhubAiRoute;
  '/devhub/ai-chat': typeof DevhubAiChatRoute;
  '/devhub/audit': typeof DevhubAuditRoute;
  '/devhub/context-packs': typeof DevhubContextPacksRoute;
  '/devhub/embedding-atlas': typeof DevhubEmbeddingAtlasRoute;
  '/devhub/evidence': typeof DevhubEvidenceRoute;
  '/devhub/exec-traces': typeof DevhubExecTracesRoute;
  '/devhub/file-ingestion': typeof DevhubFileIngestionRoute;
  '/devhub/files': typeof DevhubFilesRoute;
  '/devhub/finops': typeof DevhubFinopsRoute;
  '/devhub/governance': typeof DevhubGovernanceRoute;
  '/devhub/inbox': typeof DevhubInboxRoute;
  '/devhub/intake': typeof DevhubIntakeRoute;
  '/devhub/invites': typeof DevhubInvitesRoute;
  '/devhub/models': typeof DevhubModelsRoute;
  '/devhub/platform': typeof DevhubPlatformRoute;
  '/devhub/rag': typeof DevhubRagRoute;
  '/devhub/release': typeof DevhubReleaseRoute;
  '/devhub/remote-db': typeof DevhubRemoteDbRoute;
  '/devhub/report-templates': typeof DevhubReportTemplatesRoute;
  '/devhub/requests': typeof DevhubRequestsRoute;
  '/devhub/resources': typeof DevhubResourcesRoute;
  '/devhub/runtime': typeof DevhubRuntimeRoute;
  '/devhub/runtime-cockpit': typeof DevhubRuntimeCockpitRoute;
  '/devhub/runtime-control': typeof DevhubRuntimeControlRoute;
  '/devhub/scheduler': typeof DevhubSchedulerRoute;
  '/devhub/scripts': typeof DevhubScriptsRoute;
  '/devhub/secrets': typeof DevhubSecretsRoute;
  '/devhub/self-update': typeof DevhubSelfUpdateRoute;
  '/devhub/settings': typeof DevhubSettingsRoute;
  '/devhub/system-map': typeof DevhubSystemMapRoute;
  '/devhub/tasks': typeof DevhubTasksRoute;
  '/devhub/tool-gateway': typeof DevhubToolGatewayRoute;
  '/devhub/traces': typeof DevhubTracesRoute;
  '/devhub/white-label': typeof DevhubWhiteLabelRoute;
  '/devhub/workers': typeof DevhubWorkersRoute;
  '/devhub/workflows': typeof DevhubWorkflowsRoute;
  '/plugins/$pluginId': typeof PluginsPluginIdRoute;
  '/tenant-plane/$spokeId': typeof TenantPlaneSpokeIdRoute;
  '/devhub': typeof DevhubIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/automations': typeof AutomationsRoute;
  '/chat': typeof ChatRoute;
  '/client-workroom': typeof ClientWorkroomRoute;
  '/dashboard': typeof DashboardRoute;
  '/devhub': typeof DevhubRouteWithChildren;
  '/documents': typeof DocumentsRoute;
  '/ingest': typeof IngestRoute;
  '/login': typeof LoginRoute;
  '/notifications': typeof NotificationsRoute;
  '/onboarding': typeof OnboardingRoute;
  '/ops': typeof OpsRoute;
  '/permission-ceremony': typeof PermissionCeremonyRoute;
  '/plugins': typeof PluginsRouteWithChildren;
  '/queries': typeof QueriesRoute;
  '/reports': typeof ReportsRoute;
  '/runtime-cockpit': typeof RuntimeCockpitRoute;
  '/settings': typeof SettingsRoute;
  '/sign-in': typeof SignInRoute;
  '/step-up': typeof StepUpRoute;
  '/support': typeof SupportRoute;
  '/tenant-plane': typeof TenantPlaneRouteWithChildren;
  '/tenant-selection': typeof TenantSelectionRoute;
  '/control-plane/$spokeId': typeof ControlPlaneSpokeIdRoute;
  '/devhub/action-frames': typeof DevhubActionFramesRoute;
  '/devhub/activation': typeof DevhubActivationRoute;
  '/devhub/adobe': typeof DevhubAdobeRoute;
  '/devhub/agents': typeof DevhubAgentsRoute;
  '/devhub/ai': typeof DevhubAiRoute;
  '/devhub/ai-chat': typeof DevhubAiChatRoute;
  '/devhub/audit': typeof DevhubAuditRoute;
  '/devhub/context-packs': typeof DevhubContextPacksRoute;
  '/devhub/embedding-atlas': typeof DevhubEmbeddingAtlasRoute;
  '/devhub/evidence': typeof DevhubEvidenceRoute;
  '/devhub/exec-traces': typeof DevhubExecTracesRoute;
  '/devhub/file-ingestion': typeof DevhubFileIngestionRoute;
  '/devhub/files': typeof DevhubFilesRoute;
  '/devhub/finops': typeof DevhubFinopsRoute;
  '/devhub/governance': typeof DevhubGovernanceRoute;
  '/devhub/inbox': typeof DevhubInboxRoute;
  '/devhub/intake': typeof DevhubIntakeRoute;
  '/devhub/invites': typeof DevhubInvitesRoute;
  '/devhub/models': typeof DevhubModelsRoute;
  '/devhub/platform': typeof DevhubPlatformRoute;
  '/devhub/rag': typeof DevhubRagRoute;
  '/devhub/release': typeof DevhubReleaseRoute;
  '/devhub/remote-db': typeof DevhubRemoteDbRoute;
  '/devhub/report-templates': typeof DevhubReportTemplatesRoute;
  '/devhub/requests': typeof DevhubRequestsRoute;
  '/devhub/resources': typeof DevhubResourcesRoute;
  '/devhub/runtime': typeof DevhubRuntimeRoute;
  '/devhub/runtime-cockpit': typeof DevhubRuntimeCockpitRoute;
  '/devhub/runtime-control': typeof DevhubRuntimeControlRoute;
  '/devhub/scheduler': typeof DevhubSchedulerRoute;
  '/devhub/scripts': typeof DevhubScriptsRoute;
  '/devhub/secrets': typeof DevhubSecretsRoute;
  '/devhub/self-update': typeof DevhubSelfUpdateRoute;
  '/devhub/settings': typeof DevhubSettingsRoute;
  '/devhub/system-map': typeof DevhubSystemMapRoute;
  '/devhub/tasks': typeof DevhubTasksRoute;
  '/devhub/tool-gateway': typeof DevhubToolGatewayRoute;
  '/devhub/traces': typeof DevhubTracesRoute;
  '/devhub/white-label': typeof DevhubWhiteLabelRoute;
  '/devhub/workers': typeof DevhubWorkersRoute;
  '/devhub/workflows': typeof DevhubWorkflowsRoute;
  '/plugins/$pluginId': typeof PluginsPluginIdRoute;
  '/tenant-plane/$spokeId': typeof TenantPlaneSpokeIdRoute;
  '/devhub/': typeof DevhubIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/automations'
    | '/chat'
    | '/client-workroom'
    | '/dashboard'
    | '/devhub'
    | '/documents'
    | '/ingest'
    | '/login'
    | '/notifications'
    | '/onboarding'
    | '/ops'
    | '/permission-ceremony'
    | '/plugins'
    | '/queries'
    | '/reports'
    | '/runtime-cockpit'
    | '/settings'
    | '/sign-in'
    | '/step-up'
    | '/support'
    | '/tenant-plane'
    | '/tenant-selection'
    | '/control-plane/$spokeId'
    | '/devhub/action-frames'
    | '/devhub/activation'
    | '/devhub/adobe'
    | '/devhub/agents'
    | '/devhub/ai'
    | '/devhub/ai-chat'
    | '/devhub/audit'
    | '/devhub/context-packs'
    | '/devhub/embedding-atlas'
    | '/devhub/evidence'
    | '/devhub/exec-traces'
    | '/devhub/file-ingestion'
    | '/devhub/files'
    | '/devhub/finops'
    | '/devhub/governance'
    | '/devhub/inbox'
    | '/devhub/intake'
    | '/devhub/invites'
    | '/devhub/models'
    | '/devhub/platform'
    | '/devhub/rag'
    | '/devhub/release'
    | '/devhub/remote-db'
    | '/devhub/report-templates'
    | '/devhub/requests'
    | '/devhub/resources'
    | '/devhub/runtime'
    | '/devhub/runtime-cockpit'
    | '/devhub/runtime-control'
    | '/devhub/scheduler'
    | '/devhub/scripts'
    | '/devhub/secrets'
    | '/devhub/self-update'
    | '/devhub/settings'
    | '/devhub/system-map'
    | '/devhub/tasks'
    | '/devhub/tool-gateway'
    | '/devhub/traces'
    | '/devhub/white-label'
    | '/devhub/workers'
    | '/devhub/workflows'
    | '/plugins/$pluginId'
    | '/tenant-plane/$spokeId'
    | '/devhub/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/automations'
    | '/chat'
    | '/client-workroom'
    | '/dashboard'
    | '/documents'
    | '/ingest'
    | '/login'
    | '/notifications'
    | '/onboarding'
    | '/ops'
    | '/permission-ceremony'
    | '/plugins'
    | '/queries'
    | '/reports'
    | '/runtime-cockpit'
    | '/settings'
    | '/sign-in'
    | '/step-up'
    | '/support'
    | '/tenant-plane'
    | '/tenant-selection'
    | '/control-plane/$spokeId'
    | '/devhub/action-frames'
    | '/devhub/activation'
    | '/devhub/adobe'
    | '/devhub/agents'
    | '/devhub/ai'
    | '/devhub/ai-chat'
    | '/devhub/audit'
    | '/devhub/context-packs'
    | '/devhub/embedding-atlas'
    | '/devhub/evidence'
    | '/devhub/exec-traces'
    | '/devhub/file-ingestion'
    | '/devhub/files'
    | '/devhub/finops'
    | '/devhub/governance'
    | '/devhub/inbox'
    | '/devhub/intake'
    | '/devhub/invites'
    | '/devhub/models'
    | '/devhub/platform'
    | '/devhub/rag'
    | '/devhub/release'
    | '/devhub/remote-db'
    | '/devhub/report-templates'
    | '/devhub/requests'
    | '/devhub/resources'
    | '/devhub/runtime'
    | '/devhub/runtime-cockpit'
    | '/devhub/runtime-control'
    | '/devhub/scheduler'
    | '/devhub/scripts'
    | '/devhub/secrets'
    | '/devhub/self-update'
    | '/devhub/settings'
    | '/devhub/system-map'
    | '/devhub/tasks'
    | '/devhub/tool-gateway'
    | '/devhub/traces'
    | '/devhub/white-label'
    | '/devhub/workers'
    | '/devhub/workflows'
    | '/plugins/$pluginId'
    | '/tenant-plane/$spokeId'
    | '/devhub';
  id:
    | '__root__'
    | '/'
    | '/automations'
    | '/chat'
    | '/client-workroom'
    | '/dashboard'
    | '/devhub'
    | '/documents'
    | '/ingest'
    | '/login'
    | '/notifications'
    | '/onboarding'
    | '/ops'
    | '/permission-ceremony'
    | '/plugins'
    | '/queries'
    | '/reports'
    | '/runtime-cockpit'
    | '/settings'
    | '/sign-in'
    | '/step-up'
    | '/support'
    | '/tenant-plane'
    | '/tenant-selection'
    | '/control-plane/$spokeId'
    | '/devhub/action-frames'
    | '/devhub/activation'
    | '/devhub/adobe'
    | '/devhub/agents'
    | '/devhub/ai'
    | '/devhub/ai-chat'
    | '/devhub/audit'
    | '/devhub/context-packs'
    | '/devhub/embedding-atlas'
    | '/devhub/evidence'
    | '/devhub/exec-traces'
    | '/devhub/file-ingestion'
    | '/devhub/files'
    | '/devhub/finops'
    | '/devhub/governance'
    | '/devhub/inbox'
    | '/devhub/intake'
    | '/devhub/invites'
    | '/devhub/models'
    | '/devhub/platform'
    | '/devhub/rag'
    | '/devhub/release'
    | '/devhub/remote-db'
    | '/devhub/report-templates'
    | '/devhub/requests'
    | '/devhub/resources'
    | '/devhub/runtime'
    | '/devhub/runtime-cockpit'
    | '/devhub/runtime-control'
    | '/devhub/scheduler'
    | '/devhub/scripts'
    | '/devhub/secrets'
    | '/devhub/self-update'
    | '/devhub/settings'
    | '/devhub/system-map'
    | '/devhub/tasks'
    | '/devhub/tool-gateway'
    | '/devhub/traces'
    | '/devhub/white-label'
    | '/devhub/workers'
    | '/devhub/workflows'
    | '/plugins/$pluginId'
    | '/tenant-plane/$spokeId'
    | '/devhub/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AutomationsRoute: typeof AutomationsRoute;
  ChatRoute: typeof ChatRoute;
  ClientWorkroomRoute: typeof ClientWorkroomRoute;
  DashboardRoute: typeof DashboardRoute;
  DevhubRoute: typeof DevhubRouteWithChildren;
  DocumentsRoute: typeof DocumentsRoute;
  IngestRoute: typeof IngestRoute;
  LoginRoute: typeof LoginRoute;
  NotificationsRoute: typeof NotificationsRoute;
  OnboardingRoute: typeof OnboardingRoute;
  OpsRoute: typeof OpsRoute;
  PermissionCeremonyRoute: typeof PermissionCeremonyRoute;
  PluginsRoute: typeof PluginsRouteWithChildren;
  QueriesRoute: typeof QueriesRoute;
  ReportsRoute: typeof ReportsRoute;
  RuntimeCockpitRoute: typeof RuntimeCockpitRoute;
  SettingsRoute: typeof SettingsRoute;
  SignInRoute: typeof SignInRoute;
  StepUpRoute: typeof StepUpRoute;
  SupportRoute: typeof SupportRoute;
  TenantPlaneRoute: typeof TenantPlaneRouteWithChildren;
  TenantSelectionRoute: typeof TenantSelectionRoute;
  ControlPlaneSpokeIdRoute: typeof ControlPlaneSpokeIdRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/tenant-selection': {
      id: '/tenant-selection';
      path: '/tenant-selection';
      fullPath: '/tenant-selection';
      preLoaderRoute: typeof TenantSelectionRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/tenant-plane': {
      id: '/tenant-plane';
      path: '/tenant-plane';
      fullPath: '/tenant-plane';
      preLoaderRoute: typeof TenantPlaneRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/support': {
      id: '/support';
      path: '/support';
      fullPath: '/support';
      preLoaderRoute: typeof SupportRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/step-up': {
      id: '/step-up';
      path: '/step-up';
      fullPath: '/step-up';
      preLoaderRoute: typeof StepUpRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/sign-in': {
      id: '/sign-in';
      path: '/sign-in';
      fullPath: '/sign-in';
      preLoaderRoute: typeof SignInRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings': {
      id: '/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof SettingsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/runtime-cockpit': {
      id: '/runtime-cockpit';
      path: '/runtime-cockpit';
      fullPath: '/runtime-cockpit';
      preLoaderRoute: typeof RuntimeCockpitRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reports': {
      id: '/reports';
      path: '/reports';
      fullPath: '/reports';
      preLoaderRoute: typeof ReportsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/queries': {
      id: '/queries';
      path: '/queries';
      fullPath: '/queries';
      preLoaderRoute: typeof QueriesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/plugins': {
      id: '/plugins';
      path: '/plugins';
      fullPath: '/plugins';
      preLoaderRoute: typeof PluginsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/permission-ceremony': {
      id: '/permission-ceremony';
      path: '/permission-ceremony';
      fullPath: '/permission-ceremony';
      preLoaderRoute: typeof PermissionCeremonyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/ops': {
      id: '/ops';
      path: '/ops';
      fullPath: '/ops';
      preLoaderRoute: typeof OpsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/onboarding': {
      id: '/onboarding';
      path: '/onboarding';
      fullPath: '/onboarding';
      preLoaderRoute: typeof OnboardingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/notifications': {
      id: '/notifications';
      path: '/notifications';
      fullPath: '/notifications';
      preLoaderRoute: typeof NotificationsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/ingest': {
      id: '/ingest';
      path: '/ingest';
      fullPath: '/ingest';
      preLoaderRoute: typeof IngestRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/documents': {
      id: '/documents';
      path: '/documents';
      fullPath: '/documents';
      preLoaderRoute: typeof DocumentsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/devhub': {
      id: '/devhub';
      path: '/devhub';
      fullPath: '/devhub';
      preLoaderRoute: typeof DevhubRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/dashboard': {
      id: '/dashboard';
      path: '/dashboard';
      fullPath: '/dashboard';
      preLoaderRoute: typeof DashboardRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/client-workroom': {
      id: '/client-workroom';
      path: '/client-workroom';
      fullPath: '/client-workroom';
      preLoaderRoute: typeof ClientWorkroomRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/chat': {
      id: '/chat';
      path: '/chat';
      fullPath: '/chat';
      preLoaderRoute: typeof ChatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/automations': {
      id: '/automations';
      path: '/automations';
      fullPath: '/automations';
      preLoaderRoute: typeof AutomationsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/devhub/': {
      id: '/devhub/';
      path: '/';
      fullPath: '/devhub/';
      preLoaderRoute: typeof DevhubIndexRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/tenant-plane/$spokeId': {
      id: '/tenant-plane/$spokeId';
      path: '/$spokeId';
      fullPath: '/tenant-plane/$spokeId';
      preLoaderRoute: typeof TenantPlaneSpokeIdRouteImport;
      parentRoute: typeof TenantPlaneRoute;
    };
    '/plugins/$pluginId': {
      id: '/plugins/$pluginId';
      path: '/$pluginId';
      fullPath: '/plugins/$pluginId';
      preLoaderRoute: typeof PluginsPluginIdRouteImport;
      parentRoute: typeof PluginsRoute;
    };
    '/devhub/workflows': {
      id: '/devhub/workflows';
      path: '/workflows';
      fullPath: '/devhub/workflows';
      preLoaderRoute: typeof DevhubWorkflowsRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/workers': {
      id: '/devhub/workers';
      path: '/workers';
      fullPath: '/devhub/workers';
      preLoaderRoute: typeof DevhubWorkersRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/white-label': {
      id: '/devhub/white-label';
      path: '/white-label';
      fullPath: '/devhub/white-label';
      preLoaderRoute: typeof DevhubWhiteLabelRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/traces': {
      id: '/devhub/traces';
      path: '/traces';
      fullPath: '/devhub/traces';
      preLoaderRoute: typeof DevhubTracesRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/tool-gateway': {
      id: '/devhub/tool-gateway';
      path: '/tool-gateway';
      fullPath: '/devhub/tool-gateway';
      preLoaderRoute: typeof DevhubToolGatewayRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/tasks': {
      id: '/devhub/tasks';
      path: '/tasks';
      fullPath: '/devhub/tasks';
      preLoaderRoute: typeof DevhubTasksRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/system-map': {
      id: '/devhub/system-map';
      path: '/system-map';
      fullPath: '/devhub/system-map';
      preLoaderRoute: typeof DevhubSystemMapRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/settings': {
      id: '/devhub/settings';
      path: '/settings';
      fullPath: '/devhub/settings';
      preLoaderRoute: typeof DevhubSettingsRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/self-update': {
      id: '/devhub/self-update';
      path: '/self-update';
      fullPath: '/devhub/self-update';
      preLoaderRoute: typeof DevhubSelfUpdateRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/secrets': {
      id: '/devhub/secrets';
      path: '/secrets';
      fullPath: '/devhub/secrets';
      preLoaderRoute: typeof DevhubSecretsRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/scripts': {
      id: '/devhub/scripts';
      path: '/scripts';
      fullPath: '/devhub/scripts';
      preLoaderRoute: typeof DevhubScriptsRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/scheduler': {
      id: '/devhub/scheduler';
      path: '/scheduler';
      fullPath: '/devhub/scheduler';
      preLoaderRoute: typeof DevhubSchedulerRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/runtime-control': {
      id: '/devhub/runtime-control';
      path: '/runtime-control';
      fullPath: '/devhub/runtime-control';
      preLoaderRoute: typeof DevhubRuntimeControlRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/runtime-cockpit': {
      id: '/devhub/runtime-cockpit';
      path: '/runtime-cockpit';
      fullPath: '/devhub/runtime-cockpit';
      preLoaderRoute: typeof DevhubRuntimeCockpitRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/runtime': {
      id: '/devhub/runtime';
      path: '/runtime';
      fullPath: '/devhub/runtime';
      preLoaderRoute: typeof DevhubRuntimeRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/resources': {
      id: '/devhub/resources';
      path: '/resources';
      fullPath: '/devhub/resources';
      preLoaderRoute: typeof DevhubResourcesRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/requests': {
      id: '/devhub/requests';
      path: '/requests';
      fullPath: '/devhub/requests';
      preLoaderRoute: typeof DevhubRequestsRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/report-templates': {
      id: '/devhub/report-templates';
      path: '/report-templates';
      fullPath: '/devhub/report-templates';
      preLoaderRoute: typeof DevhubReportTemplatesRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/remote-db': {
      id: '/devhub/remote-db';
      path: '/remote-db';
      fullPath: '/devhub/remote-db';
      preLoaderRoute: typeof DevhubRemoteDbRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/release': {
      id: '/devhub/release';
      path: '/release';
      fullPath: '/devhub/release';
      preLoaderRoute: typeof DevhubReleaseRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/rag': {
      id: '/devhub/rag';
      path: '/rag';
      fullPath: '/devhub/rag';
      preLoaderRoute: typeof DevhubRagRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/platform': {
      id: '/devhub/platform';
      path: '/platform';
      fullPath: '/devhub/platform';
      preLoaderRoute: typeof DevhubPlatformRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/models': {
      id: '/devhub/models';
      path: '/models';
      fullPath: '/devhub/models';
      preLoaderRoute: typeof DevhubModelsRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/invites': {
      id: '/devhub/invites';
      path: '/invites';
      fullPath: '/devhub/invites';
      preLoaderRoute: typeof DevhubInvitesRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/intake': {
      id: '/devhub/intake';
      path: '/intake';
      fullPath: '/devhub/intake';
      preLoaderRoute: typeof DevhubIntakeRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/inbox': {
      id: '/devhub/inbox';
      path: '/inbox';
      fullPath: '/devhub/inbox';
      preLoaderRoute: typeof DevhubInboxRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/governance': {
      id: '/devhub/governance';
      path: '/governance';
      fullPath: '/devhub/governance';
      preLoaderRoute: typeof DevhubGovernanceRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/finops': {
      id: '/devhub/finops';
      path: '/finops';
      fullPath: '/devhub/finops';
      preLoaderRoute: typeof DevhubFinopsRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/files': {
      id: '/devhub/files';
      path: '/files';
      fullPath: '/devhub/files';
      preLoaderRoute: typeof DevhubFilesRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/file-ingestion': {
      id: '/devhub/file-ingestion';
      path: '/file-ingestion';
      fullPath: '/devhub/file-ingestion';
      preLoaderRoute: typeof DevhubFileIngestionRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/exec-traces': {
      id: '/devhub/exec-traces';
      path: '/exec-traces';
      fullPath: '/devhub/exec-traces';
      preLoaderRoute: typeof DevhubExecTracesRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/evidence': {
      id: '/devhub/evidence';
      path: '/evidence';
      fullPath: '/devhub/evidence';
      preLoaderRoute: typeof DevhubEvidenceRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/embedding-atlas': {
      id: '/devhub/embedding-atlas';
      path: '/embedding-atlas';
      fullPath: '/devhub/embedding-atlas';
      preLoaderRoute: typeof DevhubEmbeddingAtlasRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/context-packs': {
      id: '/devhub/context-packs';
      path: '/context-packs';
      fullPath: '/devhub/context-packs';
      preLoaderRoute: typeof DevhubContextPacksRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/audit': {
      id: '/devhub/audit';
      path: '/audit';
      fullPath: '/devhub/audit';
      preLoaderRoute: typeof DevhubAuditRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/ai-chat': {
      id: '/devhub/ai-chat';
      path: '/ai-chat';
      fullPath: '/devhub/ai-chat';
      preLoaderRoute: typeof DevhubAiChatRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/ai': {
      id: '/devhub/ai';
      path: '/ai';
      fullPath: '/devhub/ai';
      preLoaderRoute: typeof DevhubAiRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/agents': {
      id: '/devhub/agents';
      path: '/agents';
      fullPath: '/devhub/agents';
      preLoaderRoute: typeof DevhubAgentsRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/adobe': {
      id: '/devhub/adobe';
      path: '/adobe';
      fullPath: '/devhub/adobe';
      preLoaderRoute: typeof DevhubAdobeRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/activation': {
      id: '/devhub/activation';
      path: '/activation';
      fullPath: '/devhub/activation';
      preLoaderRoute: typeof DevhubActivationRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/devhub/action-frames': {
      id: '/devhub/action-frames';
      path: '/action-frames';
      fullPath: '/devhub/action-frames';
      preLoaderRoute: typeof DevhubActionFramesRouteImport;
      parentRoute: typeof DevhubRoute;
    };
    '/control-plane/$spokeId': {
      id: '/control-plane/$spokeId';
      path: '/control-plane/$spokeId';
      fullPath: '/control-plane/$spokeId';
      preLoaderRoute: typeof ControlPlaneSpokeIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

interface DevhubRouteChildren {
  DevhubActionFramesRoute: typeof DevhubActionFramesRoute;
  DevhubActivationRoute: typeof DevhubActivationRoute;
  DevhubAdobeRoute: typeof DevhubAdobeRoute;
  DevhubAgentsRoute: typeof DevhubAgentsRoute;
  DevhubAiRoute: typeof DevhubAiRoute;
  DevhubAiChatRoute: typeof DevhubAiChatRoute;
  DevhubAuditRoute: typeof DevhubAuditRoute;
  DevhubContextPacksRoute: typeof DevhubContextPacksRoute;
  DevhubEmbeddingAtlasRoute: typeof DevhubEmbeddingAtlasRoute;
  DevhubEvidenceRoute: typeof DevhubEvidenceRoute;
  DevhubExecTracesRoute: typeof DevhubExecTracesRoute;
  DevhubFileIngestionRoute: typeof DevhubFileIngestionRoute;
  DevhubFilesRoute: typeof DevhubFilesRoute;
  DevhubFinopsRoute: typeof DevhubFinopsRoute;
  DevhubGovernanceRoute: typeof DevhubGovernanceRoute;
  DevhubInboxRoute: typeof DevhubInboxRoute;
  DevhubIntakeRoute: typeof DevhubIntakeRoute;
  DevhubInvitesRoute: typeof DevhubInvitesRoute;
  DevhubModelsRoute: typeof DevhubModelsRoute;
  DevhubPlatformRoute: typeof DevhubPlatformRoute;
  DevhubRagRoute: typeof DevhubRagRoute;
  DevhubReleaseRoute: typeof DevhubReleaseRoute;
  DevhubRemoteDbRoute: typeof DevhubRemoteDbRoute;
  DevhubReportTemplatesRoute: typeof DevhubReportTemplatesRoute;
  DevhubRequestsRoute: typeof DevhubRequestsRoute;
  DevhubResourcesRoute: typeof DevhubResourcesRoute;
  DevhubRuntimeRoute: typeof DevhubRuntimeRoute;
  DevhubRuntimeCockpitRoute: typeof DevhubRuntimeCockpitRoute;
  DevhubRuntimeControlRoute: typeof DevhubRuntimeControlRoute;
  DevhubSchedulerRoute: typeof DevhubSchedulerRoute;
  DevhubScriptsRoute: typeof DevhubScriptsRoute;
  DevhubSecretsRoute: typeof DevhubSecretsRoute;
  DevhubSelfUpdateRoute: typeof DevhubSelfUpdateRoute;
  DevhubSettingsRoute: typeof DevhubSettingsRoute;
  DevhubSystemMapRoute: typeof DevhubSystemMapRoute;
  DevhubTasksRoute: typeof DevhubTasksRoute;
  DevhubToolGatewayRoute: typeof DevhubToolGatewayRoute;
  DevhubTracesRoute: typeof DevhubTracesRoute;
  DevhubWhiteLabelRoute: typeof DevhubWhiteLabelRoute;
  DevhubWorkersRoute: typeof DevhubWorkersRoute;
  DevhubWorkflowsRoute: typeof DevhubWorkflowsRoute;
  DevhubIndexRoute: typeof DevhubIndexRoute;
}

const DevhubRouteChildren: DevhubRouteChildren = {
  DevhubActionFramesRoute: DevhubActionFramesRoute,
  DevhubActivationRoute: DevhubActivationRoute,
  DevhubAdobeRoute: DevhubAdobeRoute,
  DevhubAgentsRoute: DevhubAgentsRoute,
  DevhubAiRoute: DevhubAiRoute,
  DevhubAiChatRoute: DevhubAiChatRoute,
  DevhubAuditRoute: DevhubAuditRoute,
  DevhubContextPacksRoute: DevhubContextPacksRoute,
  DevhubEmbeddingAtlasRoute: DevhubEmbeddingAtlasRoute,
  DevhubEvidenceRoute: DevhubEvidenceRoute,
  DevhubExecTracesRoute: DevhubExecTracesRoute,
  DevhubFileIngestionRoute: DevhubFileIngestionRoute,
  DevhubFilesRoute: DevhubFilesRoute,
  DevhubFinopsRoute: DevhubFinopsRoute,
  DevhubGovernanceRoute: DevhubGovernanceRoute,
  DevhubInboxRoute: DevhubInboxRoute,
  DevhubIntakeRoute: DevhubIntakeRoute,
  DevhubInvitesRoute: DevhubInvitesRoute,
  DevhubModelsRoute: DevhubModelsRoute,
  DevhubPlatformRoute: DevhubPlatformRoute,
  DevhubRagRoute: DevhubRagRoute,
  DevhubReleaseRoute: DevhubReleaseRoute,
  DevhubRemoteDbRoute: DevhubRemoteDbRoute,
  DevhubReportTemplatesRoute: DevhubReportTemplatesRoute,
  DevhubRequestsRoute: DevhubRequestsRoute,
  DevhubResourcesRoute: DevhubResourcesRoute,
  DevhubRuntimeRoute: DevhubRuntimeRoute,
  DevhubRuntimeCockpitRoute: DevhubRuntimeCockpitRoute,
  DevhubRuntimeControlRoute: DevhubRuntimeControlRoute,
  DevhubSchedulerRoute: DevhubSchedulerRoute,
  DevhubScriptsRoute: DevhubScriptsRoute,
  DevhubSecretsRoute: DevhubSecretsRoute,
  DevhubSelfUpdateRoute: DevhubSelfUpdateRoute,
  DevhubSettingsRoute: DevhubSettingsRoute,
  DevhubSystemMapRoute: DevhubSystemMapRoute,
  DevhubTasksRoute: DevhubTasksRoute,
  DevhubToolGatewayRoute: DevhubToolGatewayRoute,
  DevhubTracesRoute: DevhubTracesRoute,
  DevhubWhiteLabelRoute: DevhubWhiteLabelRoute,
  DevhubWorkersRoute: DevhubWorkersRoute,
  DevhubWorkflowsRoute: DevhubWorkflowsRoute,
  DevhubIndexRoute: DevhubIndexRoute,
};

const DevhubRouteWithChildren =
  DevhubRoute._addFileChildren(DevhubRouteChildren);

interface PluginsRouteChildren {
  PluginsPluginIdRoute: typeof PluginsPluginIdRoute;
}

const PluginsRouteChildren: PluginsRouteChildren = {
  PluginsPluginIdRoute: PluginsPluginIdRoute,
};

const PluginsRouteWithChildren =
  PluginsRoute._addFileChildren(PluginsRouteChildren);

interface TenantPlaneRouteChildren {
  TenantPlaneSpokeIdRoute: typeof TenantPlaneSpokeIdRoute;
}

const TenantPlaneRouteChildren: TenantPlaneRouteChildren = {
  TenantPlaneSpokeIdRoute: TenantPlaneSpokeIdRoute,
};

const TenantPlaneRouteWithChildren = TenantPlaneRoute._addFileChildren(
  TenantPlaneRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AutomationsRoute: AutomationsRoute,
  ChatRoute: ChatRoute,
  ClientWorkroomRoute: ClientWorkroomRoute,
  DashboardRoute: DashboardRoute,
  DevhubRoute: DevhubRouteWithChildren,
  DocumentsRoute: DocumentsRoute,
  IngestRoute: IngestRoute,
  LoginRoute: LoginRoute,
  NotificationsRoute: NotificationsRoute,
  OnboardingRoute: OnboardingRoute,
  OpsRoute: OpsRoute,
  PermissionCeremonyRoute: PermissionCeremonyRoute,
  PluginsRoute: PluginsRouteWithChildren,
  QueriesRoute: QueriesRoute,
  ReportsRoute: ReportsRoute,
  RuntimeCockpitRoute: RuntimeCockpitRoute,
  SettingsRoute: SettingsRoute,
  SignInRoute: SignInRoute,
  StepUpRoute: StepUpRoute,
  SupportRoute: SupportRoute,
  TenantPlaneRoute: TenantPlaneRouteWithChildren,
  TenantSelectionRoute: TenantSelectionRoute,
  ControlPlaneSpokeIdRoute: ControlPlaneSpokeIdRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
